export default __webpack_public_path__ + "images/fi_grid.svg";